import React from 'react';
import { Suggestion } from '../../services/analyticsService';

interface Props {
  suggestions: Suggestion[];
}

const SEVERITY_CONFIG: Record<number, { emoji: string; label: string; bgColor: string; borderColor: string }> = {
  5: { emoji: '', label: 'CRITIQUE', bgColor: 'bg-red-50', borderColor: 'border-red-200' },
  4: { emoji: '', label: 'ELEVE', bgColor: 'bg-orange-50', borderColor: 'border-orange-200' },
  3: { emoji: '', label: 'MOYEN', bgColor: 'bg-yellow-50', borderColor: 'border-yellow-200' },
  2: { emoji: '', label: 'MOYEN', bgColor: 'bg-yellow-50', borderColor: 'border-yellow-200' },
  1: { emoji: '', label: 'FAIBLE', bgColor: 'bg-green-50', borderColor: 'border-green-200' },
};

export const SuggestionsPanel: React.FC<Props> = ({ suggestions }) => {
  const sortedSuggestions = [...suggestions].sort((a, b) => b.severity - a.severity);

  return (
    <div className="bg-white p-4 rounded-lg border">
      <h3 className="text-lg font-semibold mb-4">Suggestions d'amelioration</h3>
      {sortedSuggestions.length === 0 ? (
        <p className="text-gray-500 text-center py-4">Aucune suggestion</p>
      ) : (
        <div className="space-y-3">
          {sortedSuggestions.map((suggestion, idx) => {
            const config = SEVERITY_CONFIG[suggestion.severity] || SEVERITY_CONFIG[2];

            return (
              <div
                key={idx}
                className={`p-3 rounded-lg border ${config.bgColor} ${config.borderColor}`}
              >
                <div className="flex items-start gap-2">
                  <span>{config.emoji}</span>
                  <div className="flex-1">
                    <div className="font-medium text-sm">{suggestion.message}</div>
                    {suggestion.affected_fields.length > 0 && (
                      <div className="text-xs text-gray-600 mt-1">
                        Champs : {suggestion.affected_fields.slice(0, 3).join(', ')}
                        {suggestion.affected_fields.length > 3 && ` +${suggestion.affected_fields.length - 3}`}
                      </div>
                    )}
                  </div>
                  <span className="text-xs text-gray-500">
                    {suggestion.error_count} erreurs
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
